import { Injectable } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {
  }

  /***************************************************************
   * For show success with action
   * this.toasterService.showToast("Hello", "success", "ok")
   * For show Error with action
   * this.toasterService.showToast("Hello", "error", "ok")
   * *************************************************************/
  showToast(message: string, type: string = 'success', action?: string): void {
    if (message && (message.includes('Please complete the Priority') || message.includes('Please complete the Order'))) {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Warning',
          message: 'This review will be available once all preceding reviews in the review order have been completed.',
          cancelButton: false,
          okButtonText: 'Close',
          bypassTranslation: true
        }
      });
      return;
    }
    let cl = 'toasterSuccessClass';
    let duration = 3000;
    if (type === 'error') {
      cl = 'toasterErrorClass';
      duration = 5000;
    }
    this.snackBar.open(message, action, {
      duration: duration,
      panelClass: [cl],
      horizontalPosition: 'right'
    });
  }
}
